module.exports = __webpack_public_path__ + "img/74.0ee9fd59.gif";